// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React from "react";
import {css} from "@emotion/react";
import styled from "@emotion/styled";

import {onDesktop} from "@pg-design/helpers-css";

const MAX_DESKTOP_CONTAINER_WIDTH = "103.2rem";
const PADDING_REM = 4;

export const ArticleContainer = styled.div`
    ${onDesktop(css`
        max-width: calc(${MAX_DESKTOP_CONTAINER_WIDTH} + ${PADDING_REM * 2}rem);
        margin-left: auto;
        margin-right: auto;
        padding-left: ${PADDING_REM}rem;
        padding-right: ${PADDING_REM}rem;
    `)}

    padding-left: 2rem;
    padding-right: 2rem;
`;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React from "react";
import {css} from "@emotion/react";
import styled from "@emotion/styled";

import {onDesktop} from "@pg-design/helpers-css";

const MAX_DESKTOP_CONTAINER_WIDTH = "103.2rem";
const PADDING_REM = 4;

export const ArticleContainer = styled.div`
    ${onDesktop(css`
        max-width: calc(${MAX_DESKTOP_CONTAINER_WIDTH} + ${PADDING_REM * 2}rem);
        margin-left: auto;
        margin-right: auto;
        padding-left: ${PADDING_REM}rem;
        padding-right: ${PADDING_REM}rem;
    `)}

    padding-left: 2rem;
    padding-right: 2rem;
`;
